module.exports = __webpack_public_path__ + "assets/cropped-row.3857c92c.svg";